import { render } from "./Bonuses.vue?vue&type=template&id=68bb78a7"
import script from "./Bonuses.vue?vue&type=script&lang=js"
export * from "./Bonuses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__